import i18next from "i18next";
import { find } from "lodash";
import { theme } from "style/globalStyle";

export const CredifsafeScore = Object.freeze({
  A: 'very_low',
  B: 'low',
  C: 'medium',
  D: 'high',
  E: 'no_score'
});

export const CredifsafeScoreColor = Object.freeze({
  [CredifsafeScore.A]: '#2D9F40',
  [CredifsafeScore.B]: theme.palette.primary.primary400,
  [CredifsafeScore.C]: theme.palette.warning.warning600,
  [CredifsafeScore.D]: theme.palette.error.error600,
  [CredifsafeScore.E]: theme.palette.grey.grey400,
  '-': theme.palette.grey.grey400,
});

export const CredifsafeActivityExposure = Object.freeze({
  A: 'low',
  B: 'medium',
  C: 'high',
  D: 'very_high'
});

export const CredifsafeActivityExposureColor = Object.freeze({
  [CredifsafeActivityExposure.A]: '#2D9F40',
  [CredifsafeActivityExposure.B]: theme.palette.primary.primary400,
  [CredifsafeActivityExposure.C]: theme.palette.warning.warning600,
  [CredifsafeActivityExposure.D]: theme.palette.error.error600,
  '-': theme.palette.grey.grey400,
});

export const CredifsafePreferentialRights = Object.freeze({
  ZERO: '-',
  FOLLOW: 'Follow',
  STOPPED: 'Stopped',
  WAITING: 'Waiting',
  HISTORIC: 'Historic',
  TRESOR: 'Tresor',
  URSSAF: 'URSSAF',
  DETECTED: 'Detected',
});

export const CredifsafePreferentialRightsColor = Object.freeze({
  [CredifsafePreferentialRights.ZERO]: theme.palette.grey.grey400,
  [CredifsafePreferentialRights.FOLLOW]: '#2D9F40',
  [CredifsafePreferentialRights.STOPPED]: theme.palette.grey.grey400,
  [CredifsafePreferentialRights.WAITING]: '#0070C0',
  [CredifsafePreferentialRights.TRESOR]: theme.palette.warning.warning400,
  [CredifsafePreferentialRights.URSSAF]: theme.palette.error.error600,
  [CredifsafePreferentialRights.HISTORIC]: '#0070C0',
  [CredifsafePreferentialRights.DETECTED]: theme.palette.error.error600,
  '-': theme.palette.grey.grey400,
});

export const CreditsafeIndicators = Object.freeze({
  NATIONAL_SCORE: "nationalScoreValue",
  INTERNATIONAL_SCORE: "internationalScore",
  CREDIT_LIMIT: "creditLimit",
  PAYMENT_BEHAVIOR: "dbt",
  PREFERENTIAL_RIGHTS: "preferentialStatus",
  ACTIVITY_SECTOR_EXPOSURE: "activityExposure",
  COMPANY_EXPOSURE: "companyExposure",
  FINANCIAL_STRENGTH: "financialStrength"
});

export const CreditsafeIndicatorsPrefixed =  Object.freeze([
  'creditsafe_internationalScore',
  'creditsafe_nationalScoreValue',
  'creditsafe_dbt',
  'creditsafe_preferentialStatus',
  'creditsafe_activityExposure',
  'creditsafe_companyExposure',
  'creditsafe_financialStrength'
]);;

export const CreditsafeEnumForRules = Object.freeze({
  INTERNATIONAL_SCORE: "internationalScore",
  // This includes different type of currency, it's difficult to compare so we dont use it in rules for now
  //CREDIT_LIMIT: "creditLimit",
  PAYMENT_BEHAVIOR: "dbt",
  PREFERENTIAL_RIGHTS: "preferentialStatus",
  ACTIVITY_SECTOR_EXPOSURE: "activityExposure",
  COMPANY_EXPOSURE: "companyExposure",
  FINANCIAL_STRENGTH: "financialStrength"
});

export const CreditsafeForEventsBasic = Object.freeze({
  NATIONALSCOREVALUE: "nationalScoreValue",
  CREDIT_LIMIT: "creditLimit",
  DBT: "dbt",
  COMPANYEXPOSURE: "companyExposure",
  FINANCIALSTRENGTH: "financialStrength"
});

export const CreditsafeForEventsWithDetail = Object.freeze({
  INTERNATIONALSCORE: {
    scores: CredifsafeScore,
    colors: CredifsafeScoreColor
  },
  PREFERENTIALSTATUS: {
    scores: CredifsafePreferentialRights,
    colors: CredifsafePreferentialRightsColor
  },
  ACTIVITYEXPOSURE: {
    scores: CredifsafeActivityExposure,
    colors: CredifsafeActivityExposureColor
  }
});


export const getCreditsafeOptionsDependingOnScore = (score, isForFilter) => {
  let options = [];
  if (score === CreditsafeEnumForRules.INTERNATIONAL_SCORE) {
    options.push(
      { value: 'A', label: 'A' },
      { value: 'B', label: 'B' },
      { value: 'C', label: 'C' },
      { value: 'D', label: 'D' },
      { value: 'E', label: 'E' }
    );
  } else if (score === CreditsafeEnumForRules.PREFERENTIAL_RIGHTS) {
    options.push(
      {
        value: 'Follow',
        label: i18next.t(`creditsafe.preferentialValues.Follow`),
      },
      {
        value: 'Stopped',
        label: i18next.t(`creditsafe.preferentialValues.Stopped`),
      },
      {
        value: 'Waiting',
        label: i18next.t(`creditsafe.preferentialValues.Waiting`),
      },
      {
        value: 'TRESOR',
        label: i18next.t(`creditsafe.preferentialValues.Tresor`),
      },
      {
        value: 'URSSAF',
        label: i18next.t(`creditsafe.preferentialValues.URSSAF`),
      },
      {
        value: 'Historic',
        label: i18next.t(`creditsafe.preferentialValues.Historic`),
      },
      {
        value: 'Detected',
        label: i18next.t(`creditsafe.preferentialValues.Detected`),
      }
    );
  } else if (
    score === CreditsafeEnumForRules.FINANCIAL_STRENGTH &&
    !isForFilter
  ) {
    options.push(
      { value: 'A1', label: 'A1' },
      { value: 'A2', label: 'A2' },
      { value: 'A3', label: 'A3' },
      { value: 'B1', label: 'B1' },
      { value: 'B2', label: 'B2' },
      { value: 'B3', label: 'B3' },
      { value: 'C1', label: 'C1' },
      { value: 'C2', label: 'C2' },
      { value: 'C3', label: 'C3' },
      { value: 'D', label: 'D' }
    );
  } else if (score === CreditsafeIndicators.FINANCIAL_STRENGTH && isForFilter) {
    options.push(
      { value: 'A', label: 'A' },
      { value: 'B', label: 'B' },
      { value: 'C', label: 'C' },
      { value: 'D', label: 'D' }
    );
  } else if (score === CreditsafeEnumForRules.ACTIVITY_SECTOR_EXPOSURE) {
    options.push(
      { value: 'A', label: 'A' },
      { value: 'B', label: 'B' },
      { value: 'C', label: 'C' },
      { value: 'D', label: 'D' }
    );
  } else if (score === CreditsafeEnumForRules.COMPANY_EXPOSURE) {
    options.push(
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' }
    );
  } else if (score === CreditsafeIndicators.PAYMENT_BEHAVIOR && isForFilter) {
    options.push(
      { 
        value: 'LOW', 
        label: i18next.t(`creditsafe.dashboard.scores.dbt.LOW`) 
      },
      {
        value: 'MEDIUM',
        label: i18next.t(`creditsafe.dashboard.scores.dbt.MEDIUM`),
      },
      {
        value: 'HIGH',
        label: i18next.t(`creditsafe.dashboard.scores.dbt.HIGH`),
      },
      {
        value: 'VERY_HIGH',
        label: i18next.t(`creditsafe.dashboard.scores.dbt.VERY_HIGH`),
      }
    );
  }
  return options;
};

export const parseTextNationalScore = (value) => {
    if ((value >= 1 && value < 21)) {
      return "very_high"
    } else if ((value >= 21 && value < 30)) {
      return "high"
    } else if ((value >= 30 && value < 51)) {
      return "medium"
    } else if ((value >= 51 && value < 71)) {
      return "low"
    } else if ((value >= 71 && value <= 100)) {
      return "very_low"
    } else  {
      return 'default'
    }
}

export const getCreditsafeColorDependingOnScore = (score, value) => {
  if (score === CreditsafeIndicators.INTERNATIONAL_SCORE) {
    if (value === 'NOT_STARTED') {
      return CredifsafeScoreColor['-'];
    } else {
      return CredifsafeScoreColor[CredifsafeScore[value]];
    }
  } else if (score === CreditsafeIndicators.NATIONAL_SCORE) {
    if ((value != null && value === 0) || value === 'ZERO') {
      return CredifsafeScoreColor[CredifsafeScore['D']];
    } else if ((value >= 1 && value < 21) || value === 'VERY_HIGH') {
      return CredifsafeScoreColor[CredifsafeScore['C']];
    } else if ((value >= 21 && value < 30) || value === 'HIGH') {
      return CredifsafeScoreColor[CredifsafeScore['C']];
    } else if ((value >= 30 && value < 51) || value === 'MEDIUM') {
      return theme.palette.warning.warning400;
    } else if ((value >= 51 && value < 71) || value === 'LOW') {
      return CredifsafeScoreColor[CredifsafeScore['B']];
    } else if ((value >= 71 && value <= 100) || value === 'VERY_LOW') {
      return CredifsafeScoreColor[CredifsafeScore['A']];
    } else {
      return CredifsafeScoreColor['-'];
    }
  } else if (score === CreditsafeIndicators.PREFERENTIAL_RIGHTS) {
    if (value === '' || value === '-' || value === 'NOT_SCORED' || value === 'NOT_STARTED') {
      return CredifsafePreferentialRightsColor['-'];
    }
    return CredifsafePreferentialRightsColor[CredifsafePreferentialRights[value]];
  } else if (score === CreditsafeIndicators.ACTIVITY_SECTOR_EXPOSURE) {
    if (!['A', 'B', 'C', 'D'].includes(value)) {
      return CredifsafeActivityExposureColor['-'];
    }
    return CredifsafeActivityExposureColor[CredifsafeActivityExposure[value]];
  } else if (score === CreditsafeIndicators.COMPANY_EXPOSURE) {
    if (value === '4') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['D']];
    } else if (value === '3') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['C']];
    } else if (value === '2') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['B']];
    } else if (value === '1') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['A']];
    } else {
      return CredifsafeActivityExposureColor['-'];
    }
  } else if (score === CreditsafeIndicators.FINANCIAL_STRENGTH) {
    if (value.startsWith('D')) {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['D']];
    } else if (value.startsWith('C')) {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['C']];
    } else if (value.startsWith('B')) {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['B']];
    } else if (value.startsWith('A')) {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['A']];
    } else {
      return CredifsafeActivityExposureColor['-'];
    }
  } else if (score === CreditsafeIndicators.CREDIT_LIMIT || score === CreditsafeIndicators.PAYMENT_BEHAVIOR) {
    if (value === 'LOW') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['A']];
    } else if (value === 'MEDIUM') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['B']];
    } else if (value === 'HIGH') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['C']];
    } else if (value === 'VERY_HIGH') {
      return CredifsafeActivityExposureColor[CredifsafeActivityExposure['D']];
    } else {
      return theme.palette.grey.grey400;
    }
  }
}

export const splitCreditsafeFiltersByScore = (filters) => {
  let creditsafeFilters = filters?.reduce((res, filter) => {
    const score = filter.type?.substring(11);
    const scoreObj = find(res, { score: score });
    let value = filter.id;
    if (score === CreditsafeIndicators.PREFERENTIAL_RIGHTS) {
      value = capitalize(value)
    }

    // Add a new score object if it doesnt exist.
    if (!scoreObj) {
      res.push({ score: score, values: [value] })
    } else {
      // or add the value to its existing filter values.
      scoreObj.values.push(value)
    }
    return res;
  }, []);

  // Add remaining scores with empty values if they don't already exist
  const orderedFilters = [];
  CreditsafeIndicatorsPrefixed.forEach((score) => {
    const scoreFilter = creditsafeFilters.find((filter) => filter.score === score.substring(11));
    orderedFilters.push(scoreFilter || { score: score.substring(11), values: [] });
  });

  return orderedFilters;
}

function capitalize(s) {
  return s && String(s[0]).toUpperCase() + String(s).slice(1).toLowerCase();
}